export const Types = {
  STORE_LATEST_SERVER_TIMESTAMP: 'meta/store_latest_server_timestamp'
}

export class StoreLatestServerTimeStamp implements FluxStandardAction {
  type = Types.STORE_LATEST_SERVER_TIMESTAMP
  constructor(public payload: string) {}
}
